/**
 * layout.js
 * 
 * @copyright jnakaso.com
 * 
 * contents of landing page
 * 
 */

import { AppShell, Burger, Group, UnstyledButton, Image } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import React, { ReactNode } from "react";
import { Outlet, useNavigate } from "react-router-dom";

// import classes from './layout.module.css';


function Layout(props: { children: ReactNode | ReactNode[] }) {
    const navigate = useNavigate();

    const [opened, { toggle }] = useDisclosure();

    const sections = {
        'Home': '/',
        'Schedule': '/schedule',
        'Seasons': '/seasons',
        'Info': '/info',
        'About': '/about'
    };

    return (
        <React.Fragment>
            <AppShell
                header={{ height: 80 }}
                navbar={{ width: 300, breakpoint: 'sm', collapsed: { desktop: true, mobile: !opened } }}
                padding="md"
            >
                <AppShell.Header>
                    <Group h="100%" px="md">
                        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
                        <Group justify="space-between" style={{ flex: 1 }}>
                            <Image src="logo.jpg" alt="logo" height={70} onClick={() => navigate('/')} />
                            <Group ml="xl" gap={0} visibleFrom="sm">
                                {Object.keys(sections).map(k =>
                                    <UnstyledButton key={k} className={'control'} onClick={() => navigate(sections[k])}>{k}</UnstyledButton>)}
                            </Group>
                        </Group>
                    </Group>
                </AppShell.Header>

                <AppShell.Navbar py="md" px={4}>
                    {Object.keys(sections).map(k =>
                        <UnstyledButton key={k} className={'control'} onClick={() => { navigate(sections[k]); toggle() }}>{k}</UnstyledButton>)}
                </AppShell.Navbar>

                <AppShell.Main>
                    <Outlet />
                </AppShell.Main>
            </AppShell>

        </React.Fragment>
    );

}

export default Layout;